import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { path } from 'utils/route.';

/**
 * This service is used to store all server documents in a single place
 *
 * documentLink directive is used to assign click event handler to elements
 */
@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    private documents: {
        [key: string]: {
            filename: string;
            group?: string;
        };
    } = {
        'terms-of-business': {
            filename: 'terms-of-business.pdf'
        },
        'autohog-agreement': {
            filename: 'autohog-agreement.pdf'
        },
        'add-stay': {
            filename: 'add-stay.csv'
        },
        'bulk-property-stays': {
            filename: 'bulk-property-stays.csv'
        },
        'bulk-stays': {
            filename: 'bulk-stays.csv'
        },
        claimform: {
            filename: 'claimform.pdf'
        }
    };

    public get(identifier: string): string {
        const document = this.documents[identifier];
        if (!document || !document.filename)
            throw new Error(`Document with identifier '${identifier}' does not exist.`);
        else return path([environment.origin, environment.documents, document.filename], false) ;
        //`${environment.origin}${this._config.documentsPath}/${document.filename}`
    }
}

